import camelCase from 'lodash-es/camelCase';
import upperFirst from 'lodash-es/upperFirst';

const requireComponents = import.meta.glob('~~/**/components/forms/blueprints/**/Blueprint.vue');
const components = Object.entries(requireComponents).filter(activeLayers).map(([key, value]) => ({
    key: key.replace('/Blueprint.vue', '').split('/').slice(-1).pop(),
    value
}));
const requireFilters = import.meta.glob('~~/**/components/forms/blueprints/**/Filter.vue');
const filters = Object.entries(requireFilters).filter(activeLayers).map(([key, value]) => ({
    key: key.replace('/Filter.vue', '').split('/').slice(-1).pop(),
    value
}));
const requirePresenters = import.meta.glob('~~/**/components/forms/blueprints/**/Presenter.vue');
const presenters = Object.entries(requirePresenters).filter(activeLayers).map(([key, value]) => ({
    key: key.replace('/Presenter.vue', '').split('/').slice(-1).pop(),
    value
}));

const requireTypes = import.meta.glob('~~/**/components/forms/blueprints/**/index.ts', { eager: true });
const definitions = Object.entries(requireTypes).filter(activeLayers).map(([k, p]: [string, any]) => p.Definition);
const types = Object.assign({}, ...Object.values(requireTypes).map((module: any) =>
{
    const type = upperFirst(camelCase(`${module.Definition.type}-type`));

    return { [type]: module[type] };
}));

const requireMeta = import.meta.glob('~~/**/components/forms/blueprints/**/meta.ts', { eager: true });
const metas = Object.entries(requireMeta).filter(activeLayers).map(([key, value]: [string, any]) => ({
    key: key.replace('/meta.ts', '').split('/').slice(-1).pop(),
    value: value.default
}));

export {
    components,
    filters,
    presenters,
    definitions,
    types,
    metas
};
